export default function isEmpty(value) {
  return (
    value === undefined ||
    value === null ||
    (typeof value === "object" && Object.keys(value).length === 0) || // array and object
    (typeof value === "string" && value.trim().length === 0)
  );
}
